import React, {Component} from 'react';
import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import classNames from 'classnames';
import {ANY_CHILD} from 'prop-utils';

class Label extends Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const {
            className,
            htmlFor,
            required,
            children
        } = this.props;
        const classes = classNames(
            'Label',
            className
        );

        return (
            <label
                className={classes}
                htmlFor={htmlFor}
            >
                {children}
                {required && <sup className="Label-required">*</sup>}
            </label>
        );
    }
}

Label.propTypes = {
    className: PropTypes.string,
    htmlFor: PropTypes.string,
    required: PropTypes.bool,
    children: ANY_CHILD.isRequired
};

Label.defaultProps = {
    className: '',
    required: false
};

export default Label;



// WEBPACK FOOTER //
// ./frontend/src/js/components/label/Label.jsx